import React from 'react'
import styled from 'styled-components'

import HeaderLined from '../../components/HeaderLined'
import NewsList from '../../components/NewsList'

const Wrapper = styled.section`
  width: 100%;
`

const Container = styled.div`
  margin: 0 auto;
  padding: 0 0 ${({ small }) => (small ? '0 40px' : `80px 90px`)};
  width: 100%;
`

const News = ({ newsList, small }) => {
  return (
    <Wrapper small={small}>
      <Container small={small}>
        <HeaderLined>What's on?</HeaderLined>
        <NewsList newsList={newsList} small={small} />
      </Container>
    </Wrapper>
  )
}

export default News
